/***
 * Configuration for psr sortenfinder
 *
 ***/

const colours = ['yellow', 'orange', 'red', 'green'];
const pinDiv = '<li class="d-inline-block pin-container"><div class="pin">&nbsp;</div><div class="pin-counter"></div></li>'
const nunjucks = {
	templatePath: '/template/dist/views-sortenfinder',
	config: {autoescape: true, web: {useCache : true}}
}
const initialState = {
	items: [],
	filteredItems: [],

	config: null,

	//pagination
	page: 0,

	// page language
	lang: 'default',

	// uris
	detailUri: '',
	sustainerUri:'',
	pagination: {
		page: 0
	}
}
const extendedFilterOrder =["lebenszeit","lichtbedarf","hoeheneignung","anbaueignung","bodenstruktur","bodenfeuchtigkeit","saatzeit_freiland","saatzeit_haus","pflanzzeit","bluetezeit","erntezeit","lagereignung","kulinarik","bluetenfarbe","bluetenfuellung","wuchsform","kochtyp","zierwert"]
const extendedSortByKey = ['saatzeit_freiland', 'saatzeit_haus', 'pflanzzeit', 'bluetezeit', 'erntezeit']
const extendedHidden = ["farbe_haupternte_innen","farbe_haupternte_aussen"]

const pagination = {
	initial: 10,
	reload: 5,
}

module.exports = {
	initialState,
	colours,
	pinDiv,
	nunjucks,
	extendedFilterOrder,
	extendedSortByKey,
	extendedHidden,
	jsonUri,
	pagination
}
